import React, { FC } from 'react'

import './styles.scss'

type Props = {
  error: Error
}

const DefaultErrorFallback: FC<Props> = ({ error }) => {
  console.error(error)

  return (
    <div className="dashboard error">
      <div>
        <h3>That wasn&apos;t supposed to happen.</h3>
        <p>
          We&apos;re working on getting a fix out to you as soon as possible. In the meantime,
          please try refreshing your page. Thank you!
        </p>
      </div>
      <div className="error-info">
        <div className="error-category">
          <p>Name</p>
          <div className="code">
            <code>{error.name}</code>
          </div>
        </div>

        <div className="error-category">
          <p>Message</p>
          <div className="code">
            <code>{error.message}</code>
          </div>
        </div>
      </div>
    </div>
  )
}

export default DefaultErrorFallback
